import { useState, useEffect } from 'react';

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [maxWidth, setMaxWidth] = useState(
    window.innerWidth <= 768 ? windowDimensions.width : 28 * 16
  );

  const updateWindowDimensions = () => {
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    //set the value only based on the windowDimensions.width
    if (windowDimensions.width <= 450) {
      setMaxWidth(windowDimensions.width);
    } else {
      const maxWidthInPixelUnits = 28 * 16;
      setMaxWidth(maxWidthInPixelUnits);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  return { windowDimensions, maxWidthInPixelUnits: maxWidth };
};

export default useWindowDimensions;
